export default __webpack_public_path__ + "i18n/translations/translation-fr.b1c8e252.json";